import Vue from 'vue'
import sensors from '@/trace'
import store from '@/store'
import router, { resetRouter } from '@/router'
import asyncRoutes from '@/router/routes'
import utils from '@/services/utils/config'
import constants from '@/services/constants/config'
import NProgress from 'nprogress'

import AmazonRouter from '@/router-permission/amazon-router'
import WishRouter from '@/router-permission/wish-router'
import ShopeeRouter from '@/router-permission/shopee-router'
import AliExpressRouter from '@/router-permission/aliExpress-router'
import LazadaRouter from '@/router-permission/lazada-router'
import OfflineRouter from '@/router-permission/offline-router'
import { routerChangeTrigger } from '@/services/microFeUtil'
import app from '@/main'

window.alreadySetRoute = false

const whiteList = [
  /\/user\/login/,
  /\/user\/passwd/,
  /\/user\/privacy-policy/,
  /\/user\/standalone-entry/,
  /\/user\/promotional-page/,
  /\/user\/standalone-register/,
  /\/user\/registry-success/,
  /\/static-biz-pages(\/.*)+/,
] // 不做token校验

const isInWhiteList = (path) => {
  for (let index = 0; index < whiteList.length; index++) {
    const pat = whiteList[index]
    const testRes = pat.test(path)
    if (testRes) {
      return true
    }
  }

  return false
}

export async function routerBeforeEachFunc(to, from, next) {
  console.log(from, to, location.href, '测试demo域名')
  const reg = /demo.qizhishangke.com/
  if (reg.test(location.href) && from.path === '/' && to.path !== '/user/promotional-page') {
    next({ path: '/user/promotional-page' })
    return
  }

  const trigger = routerChangeTrigger.consume()
  console.log(from, '测试进度条开始')
  if (trigger !== 's' && (from.path && !from.path.includes('promotional-page'))) {
    // 当本次更新不是是 s 触发的, 展示进度条
    NProgress.start()
  } else {
    console.log('base-app 本次更新是 s 触发, 不展示进度条')
  }

  const tokenObj = utils.getToken()
  if (to?.meta?.acl === 'all' || isInWhiteList(to.path)) {
    console.log('在白名单内')
    next()
    return
  }
  // 这里可以做页面拦截，比如做权限处理
  if (tokenObj?.token) {
    // 页签新增逻辑
    // store.dispatch('pageTag/addPageTag', { title: '', url: to.fullPath, route: to })

    if (!window.alreadySetRoute) {
      try {
        window.alreadySetRoute = true
        if (tokenObj.xFrom === 1 || tokenObj.xFrom === 2) {
          await store.dispatch('user/getBjMenuList')
        }
        // const utcTimeRes = await store.dispatch('map/getUtcTime') // 用此接口判断账号是否有可进入权限
        // if (utcTimeRes === 401 || utcTimeRes === 40022) {
        //   next({ name: 'noActive' })
        //   return
        // }
        const res = await Promise.all([
          store.dispatch('user/getUserInfo'),
          // 这个接口经常超时, 且框架暂时不需要, 隐藏
          // store.dispatch('map/getCommonMap'),
          // store.dispatch('map/flushAllCurrencyOPtions'),
          // store.dispatch('user/getInitBtnShow')
        ])
        // if (res[0]) {
        //   setUserData(res[0])
        // }
        // setUserData(res[0])

        sensors.login(JSON.stringify({
          sid: Vue.ls.get('sid'),
          account: Vue.ls.get('account'),
          token: tokenObj.token,
          xFrom: tokenObj.xFrom ? 1 : 0
        }))

        // 请求带有 redirect 重定向时，登录自动重定向到该地址
        const redirect = decodeURIComponent(from.query.redirect || to.path)
        if (to.path === redirect || redirect.indexOf('/user/login') > -1) {
          // hack方法 确保addRoutes已完成
          next({ ...to, replace: true })
        } else {
          // 跳转到目的路由
          next({ path: redirect })
        }
      } catch (err) {
        goLogin(next, tokenObj?.xFrom)
      }
    } else {
      next()
    }
  } else {
    goLogin(next, tokenObj?.xFrom)
  }
}

function goLogin(next, xFrom) {
  if (xFrom === 1) {
    // location.href = `${utils.getErpDomain()}/login?redirect=${encodeURIComponent(location.href)}&type=bi`
    location.href = `${utils.getErpDomain()}/login`
  } else {
    console.log('===需要重置登录页面的状态')
    // app?.$message?.error('系统初始化失败, 请稍后再试')
    store.dispatch('user/increaseLoginPageResetCount')
    next({ path: '/user/login' })
  }
}

/**
 * 过滤路由
 */
function filterAsyncRouter(data, permissionRoutesCode) {
  const accessedRouters = data.filter(route => {
    if (permissionRoutesCode.includes(route.name)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, permissionRoutesCode)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

// 整合用户信息
function setUserData(userData) {
  // const { AmazonId, WishId, ShopeeId, AliExpressId, LazadaId, OfflineId } = constants
  // let routerNames = ['bi-analysis']
  // userData.platformIds.forEach(id => {
  //   if (id === AliExpressId) routerNames = routerNames.concat(AliExpressRouter)
  //   if (id === LazadaId) routerNames = routerNames.concat(LazadaRouter)
  //   if (id === AmazonId) routerNames = routerNames.concat(AmazonRouter)
  //   if (id === WishId) routerNames = routerNames.concat(WishRouter)
  //   if (id === ShopeeId) routerNames = routerNames.concat(ShopeeRouter)
  //   if (id === OfflineId) routerNames = routerNames.concat(OfflineRouter)
  // })
  // routerNames = [...new Set(routerNames)]
  // const permissionRoutes = filterAsyncRouter(asyncRoutes, routerNames)
  // store.commit('user/SET_MENU', utils.deepClone(permissionRoutes))

  const permissionRoutes = []
  permissionRoutes.push({
    path: '*',
    redirect: 'noActive'
  })
  resetRouter()
  router.addRoutes(permissionRoutes)
}

export function routerAfterEachFunc(route) {
  const prefix = '旺店通ERP跨境版'
  const { title } = route.meta
  document.title = title ? `${title} - ${prefix}` : prefix
  if (!route.meta.noAutoTrace) {
    sensors.pageTrace()
  }
  console.log(route, '测试进度条结束')
  NProgress.done()
}
